import React from 'react';

function AnalyticsView() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container-app py-12">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Analytics</h1>
        <div className="card">
          <p className="text-gray-600">Analytics visualization coming soon...</p>
        </div>
      </div>
    </div>
  );
}

export default AnalyticsView;
